<template>
  <div class="text-center">
    <v-dialog v-model="dialog" width="500">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          small
          color="primary"
          class="text-unset"
          v-on="on"
          :disabled="disabled"
          >{{ $t(buttonText) }}</v-btn
        >
      </template>

      <v-card>
        <v-card-title class="headline grey lighten-2">{{
          $t("shop-select-quantity")
        }}</v-card-title>
        <v-card-text>
          <b-form-group :label="$t(buyQuestion)">
            <b-form-select
              id="inline-form-custom-select-pref"
              class="mb-2 mr-sm-2 mb-sm-0"
              :options.sync="options"
              :value="null"
              v-model="quantity"
            ></b-form-select>
          </b-form-group>
        </v-card-text>

        <v-card-text v-if="quantity &gt; 0">
          {{
            $t(`${buyConfirm}`, [
              quantity,
              ((quantity * price) / htlEur).toFixed(2),
              (available / 1e8).toFixed(2),
            ])
          }}
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialog = false" class="text-unset">
            {{ $t("common.back") }}
          </v-btn>
          <v-btn
            v-if="shopItemTxtId != null"
            :disabled="quantity === 0"
            color="error"
            text
            @click="buyButNormal"
            class="text-unset"
          >
            {{ $tc(buyCount, quantity, { count: quantity }) }}
          </v-btn>
          <v-btn
            v-else
            :disabled="quantity === 0"
            color="error"
            text
            @click="buy"
            class="text-unset"
          >
            {{ $tc(buyCount, quantity, { count: quantity }) }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import gql from "graphql-tag";
import { mapGetters } from "vuex";

export default {
  props: [
    "price",
    "disabled",
    "shopItemTxtId",
    "buttonText",
    "buyConfirm",
    "buyQuestion",
    "buyCount",
  ],
  data() {
    return {
      dialog: false,
      quantity: 0,
    };
  },
  watch: {
    // Ko se dialog odpre (dialog postane true), ponastavimo izbiro
    dialog(val) {
      if (val) {
        this.quantity = 0;
      }
    },
  },
  computed: {
    ...mapGetters({
      available: "user/available",
      htlEur: "prices/htlEur",
      rate: "prices/rate",
    }),
    options: function () {
      const fullOptions = [
        ...Array(
          Math.ceil(((this.available + 1) / 1e8 / this.price) * this.htlEur)
        ).keys(),
      ];
      // Odstranitev prvega elementa (številka 0) z uporabo slice(1)
      return fullOptions.slice(1);
    },
  },
  methods: {
    buy() {
      this.$apollo
        .mutate({
          // Query
          mutation: gql`
            mutation ($token: String!, $quantity: Int!) {
              buyTicket(token: $token, quantity: $quantity)
            }
          `,
          // Parameters
          variables: {
            token: this.rate,
            quantity: this.quantity,
          },
        })
        .then(() => {
          this.$router.go(0);
        });
    },
    //infotrend
    buyButNormal() {
      this.$apollo
        .mutate({
          // Query
          mutation: gql`
            mutation (
              $token: String!
              $quantity: Int!
              $shopItemTxtId: String!
            ) {
              buyTicketButNormal(
                token: $token
                quantity: $quantity
                shopItemTxtId: $shopItemTxtId
              )
            }
          `,
          // Parameters
          variables: {
            token: this.rate,
            quantity: this.quantity,
            shopItemTxtId: this.shopItemTxtId,
          },
        })
        .then(() => {
          this.$router.go(0);
        });
    },
  },
};
</script>

